import Select, { GroupBase, StylesConfig } from 'react-select'

export const customSelectStyles: StylesConfig<any> = {
    container: (provided, state) => ({
        ...provided,
        width: "100%",
    }),
    control: (provided, state) => ({
        ...provided,
        borderColor: "#ECECEC", 
        paddingTop: "8px",
        paddingBottom: "8px",
        fontWeight: 700,
        fontSize: "0.875rem",
        color: "#868686",
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: "#868686",
    }),
    menuList: (provided, state) => ({
        ...provided,
    }),
    option: (provided, state) => ({
        ...provided,
        fontWeight: 700,
        fontSize: "0.875rem",
        color: state.isSelected ? "white" : "#868686",
        backgroundColor: state.isSelected ? "#1E90FF" : "white",
        ":hover": {
            backgroundColor: "#1E90FF",
            color: "white",
        },
    }),
    indicatorSeparator: _ => ({
        visibility: "hidden"
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: "#99d90c",
    }),
};
